import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const MenuVersionField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="menuVersionLabel" value={customerForFullInfo?.menuVersion} />;
};

export default MenuVersionField;
